import { useTranslation } from "react-i18next";
import type { ArtMetadata } from "../../lib/schedule-presets/art-metadata";
import type { MetadataDay } from "../../lib/metadata-history/metadata-targets";
import type { DayLayoutMode } from "../../lib/metadata-builder/day-layouts";
import { weekdayKeys } from "../../lib/schedule-time/schedule-dates";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { metadataLabels } from "../editor-panel/developer-section/metadata-form-schema";
import { cn } from "../../lib/utils";
import { togglePreviewMode } from "../../lib/metadata-builder/preview-modes";
import { PreviewModeButtons } from "./PreviewModeButtons";

type ReviewSummaryProps = { metadata: ArtMetadata };

export function ReviewSummary({ metadata }: ReviewSummaryProps) {
  const { t } = useTranslation();
  const labels = metadataLabels(t);
  const previewModes = useMetadataBuilderStore(state => state.previewModes);
  const inspect = (day: MetadataDay, mode: DayLayoutMode) => {
    endMetadataMerge();
    const nextModes = togglePreviewMode(previewModes, day, mode);
    useMetadataBuilderStore.setState({ selectedDay: day, previewModes: nextModes });
    useMetadataEditingStore.getState().select(null);
  };
  const modes = ["offline", "one_slot", "two_slot"] as const;
  return <div className="space-y-2">
    <PreviewModeButtons />
    <div className="overflow-x-auto rounded border border-neutral-200">
      <table className="w-full text-left text-xs">
        <thead className="bg-neutral-50"><tr>
          <th className="px-2 py-2">{t("builder.review.day")}</th>
          {modes.map(mode => <th key={mode} className="px-2 py-2">{labels[mode]}</th>)}
        </tr></thead>
        <tbody>{weekdayKeys.map((day, index) => <tr key={day} className="border-t border-neutral-200">
          <th className="px-2 py-2 font-medium">{labels[day]}</th>
          {modes.map(state => <td key={state} className="p-1">
            <button type="button" onClick={() => inspect(day, state)}
              className={cn("w-full rounded border px-2 py-2 text-left", previewModes[day] === state ? "border-green-600 bg-green-50 text-green-800" : "border-neutral-200 hover:bg-neutral-50")}>
              <span className="block">{`${state === "offline" ? "c" : state === "one_slot" ? "a" : "b"}0${index + 1}`}</span>
              <span className="block">{t("builder.review.elementCount", { count: metadata.days[day][state].length })}</span>
            </button>
          </td>)}
        </tr>)}</tbody>
      </table>
    </div>
  </div>;
}
